import '../plugins/AccordionPlugin';
import $ from 'jquery';

// accordion menu init
export default function initAccordion() {
  ResponsiveHelper.addRange({
    '..1023': {
      on: function () {
        $('.accordion-header').slideAccordion({
          opener: '>.subtitle',
          slider: '>.slide',
          animSpeed: 300,
          customOption: true,
        });

      },
      off: function () {
        $('.accordion-header').slideAccordion('destroy');
      }
    }
  });
  ResponsiveHelper.addRange({
    '..1023': {
      on: function () {
        $('.inner-menu').slideAccordion({
          opener: '>.opener',
          slider: '>.sub-info',
          animSpeed: 300,
          customOption: false,
        });

      },
      off: function () {
        $('.inner-menu').slideAccordion('destroy');
      }
    }
  });
  $('ul.multilevel-accordion').slideAccordion({
    opener: '>a.opener',
    slider: '>div.slide',
    collapsible: true,
    animSpeed: 300,
    leaveOthersExpanded: true,
    customOption: false,
  });
  $('ul.accordion').slideAccordion({
    opener: '>a.opener',
    slider: '>div.slide',
    collapsible: true,
    animSpeed: 300,
    customOption: false,
  });
}
